import { Thing } from 'schema-dts';

import { ContentSectionWithImageRow as HygraphContentSectionWithImageRow } from '@/lib/types';

import ContentSectionWithImageRow, {
  ContentSectionWithImageRowProps,
} from '@/components/content-section-with-image-row';

import contentSectionTransformer from '@/hygraph/transformers/content-section.transformer';
import imageTransformer from '@/hygraph/transformers/image.transformer';
import imageSizingTransformer from '@/hygraph/transformers/image-sizing.transformer';
import sideTransformer from '@/hygraph/transformers/side.transformer';
import verticalSideTransformer from '@/hygraph/transformers/vertical-side.transformer';
import { TSchemaData } from '@/services/schema-service';

ContentSectionWithImageRenderer.buildSchema = buildSchema;

function buildSchema(
  component: HygraphContentSectionWithImageRow
): Partial<TSchemaData<Thing>> {
  const url = component.image?.url;
  return { images: url ? [url] : [] };
}

export default function ContentSectionWithImageRenderer(
  props: HygraphContentSectionWithImageRow
) {
  const componentProps: ContentSectionWithImageRowProps = {
    content: contentSectionTransformer(props.contentSection),
    image: imageTransformer(props.image),
    contentBackgroundImage: imageTransformer(props.contentBackgroundImage),
    imagePosition: sideTransformer(props.imagePosition),
    imageOrder: verticalSideTransformer(props.imageOrder),
    imageSizing: imageSizingTransformer(props.imageSizing),
    staticComponentAfter: props.staticComponentAfter || undefined,
  };

  if (componentProps.image && props.imageAnimateOnVisbile !== undefined) {
    componentProps.image.animateOnVisible = !!props.imageAnimateOnVisbile;
  }

  return <ContentSectionWithImageRow {...componentProps} />;
}
